<template>
  <div id="checkout">
    <div xclass="header">
      <div class="van-hairline--bottom background_color_d6f1ec van-nav-bar font_weight_bold" style="z-index: 1;">
        <div class="van-nav-bar__left" v-show="$vuetify.breakpoint.smAndDown">
          <i class="van-icon van-icon-arrow-left van-nav-bar__arrow" style="color: #000000 !important;" @click="$router.back(-1)"></i>
        </div>
        <div class="van-ellipsis van-nav-bar__title">{{ $t("cart.checkout") }}</div>
      </div>
    </div>

    <div class="content2">
      <div class="checkout-title">Review your order</div>

      <van-row class="order-item" v-for="(item, index) in orderItems" :key="index">
        <van-col class="qty" span="2">{{ item.Quantity }}</van-col>
        <van-col class="title" span="14">
          {{ item.Title }}
          <div class="shipping-note" v-if="shippingMethod == '2' && !item.FreeShipping && item.ShippingNote != ''">
            {{ item.ShippingNote }}
          </div>
        </van-col>
        <van-col class="price" span="7">{{ item.Extension | currency }}</van-col>
      </van-row>
      <div class="order-total">
        <van-row class="subtotal">
          <van-col class="title" span="16">Subtotal</van-col>
          <van-col class="amount" span="7">{{ orderHeader.Subtotal | currency }}</van-col>
        </van-row>
        <van-row class="freight">
          <van-col class="title" span="16">Freight</van-col>
          <van-col class="amount" span="7">{{ orderHeader.Freight | currency }}</van-col>
        </van-row>
        <van-row class="taxes">
          <van-col class="title" span="16">Taxes</van-col>
          <van-col class="amount" span="7">{{ orderHeader.Taxes | currency }}</van-col>
        </van-row>
        <van-row class="total">
          <van-col class="title" span="16">Total</van-col>
          <van-col class="amount" span="7">{{ orderHeader.Total | currency }}</van-col>
        </van-row>
      </div>

      <van-row v-if="shippingMethod == '2' && orderHeader.HasSpecialShippingItem && orderHeader.SpecialShippingMessage != ''">
        <van-col span="2"></van-col>
        <van-col span="20" class="special-shipping-message">{{ orderHeader.SpecialShippingMessage }}</van-col>
      </van-row>

      <van-row v-if="orderHeader.CheckOutMessage != ''">
        <van-col span="2"></van-col>
        <van-col span="20" class="special-shipping-message">{{ orderHeader.CheckOutMessage }}</van-col>
      </van-row>

      <!--       <div
        class="special-shipping-message"
        v-if="shippingMethod=='2' && orderHeader.HasSpecialShippingItem && orderHeader.SpecialShippingMessage!=''"
      >{{orderHeader.SpecialShippingMessage}}</div>-->

      <van-divider />
      <!-- <van-button round class="change-cart-button" @click="placeOrder(true)">dummy payt</van-button> -->

      <div>
        <van-radio-group v-model="shippingMethod" @change="addressChanged">
          <van-radio name="1">Pickup in store</van-radio>
          <van-radio-group v-show="shippingMethod == '1'" v-model="storeLocationSelected" style="padding-left: 20px;" @change="addressChanged">
            <van-radio shape="square" v-for="(address, index) in storeLocations" :key="index" :name="address.storeId">
              <div class="address-box">
                <div>{{ address.address }}</div>
                <div>{{ address.city }}, {{ address.postal }}</div>
                <div>{{ address.phone }}</div>
              </div>
            </van-radio>
          </van-radio-group>

          <div style="display:flex;">
            <van-radio name="2" style="width:210px;">Ship to</van-radio>
            <van-button round class="address-add-button" @click="addAddress">Add</van-button>
          </div>

          <van-radio-group v-show="shippingMethod == '2'" v-model="shippingAddressSelected" style="padding-left: 20px;" @change="addressChanged">
            <van-radio shape="square" v-for="(address, index) in addresses" :key="index" :name="address.AddrName">
              <div class="address-box">
                <!-- <div>{{ address.AddrName }}</div> -->
                <div v-show="address.AddrAttn != ''">{{ address.AddrAttn }}</div>
                <div>{{ address.AddrLine1 }}</div>
                <div v-show="address.AddrLine2 != ''">{{ address.AddrLine2 }}</div>
                <div>{{ address.AddrCity }}, {{ address.AddrProv }} {{ address.AddrPostalCode }}</div>
                <!-- <div>{{ address.AddrCountry }}</div> -->
                <div v-show="address.AddrPhone != ''">Phone: {{ address.AddrPhone }}</div>
              </div>
            </van-radio>
          </van-radio-group>
        </van-radio-group>
      </div>

      <van-divider />

      <div style="display: flex; align-items: center;margin: 0px 10px;margin-top:10px">
        <div class="font-weight-bold" style="width:200px;">Billing Address</div>
        <van-button round class="address-add-button" @click="addAddress">Add</van-button>
      </div>
      <div v-show="shippingMethod == '2' && shippingAddressSelected != ''">
        <van-checkbox shape="square" v-model="sameAsShippingAddress" style="margin: 10px;">Same as shipping address</van-checkbox>
      </div>
      <van-radio-group v-show="shippingMethod == '1' || (shippingMethod == '2' && !sameAsShippingAddress)" v-model="billingAddressSelected" style="padding-left: 20px;">
        <van-radio shape="square" v-for="(address, index) in addresses" :key="index" :name="address.AddrName">
          <div class="address-box">
            <!-- <div>{{ address.AddrName }}</div> -->
            <div v-show="address.AddrAttn != ''">{{ address.AddrAttn }}</div>
            <div>{{ address.AddrLine1 }}</div>
            <div v-show="address.AddrLine2 != ''">{{ address.AddrLine2 }}</div>
            <div>{{ address.AddrCity }}, {{ address.AddrProv }} {{ address.AddrPostalCode }}</div>
            <!-- <div>{{ address.AddrCountry }}</div> -->
            <div v-show="address.AddrPhone != ''">Phone: {{ address.AddrPhone }}</div>
          </div>
        </van-radio>
      </van-radio-group>

      <van-divider />

      <div class="font-weight-bold" style="margin: 0px 10px;margin-top:10px" v-show="orderHeader && orderHeader.Total > 0">
        Payment
        <v-radio-group row class="ss-pay-method" v-model="payMethod" @change="payMethodChanged">
          <v-radio class="my-1" value="5" label="Credit Card" />
          <v-radio class="my-1" value="6" label="Alipay" />
          <v-radio class="my-1" value="7" label="WeChatPay" />
        </v-radio-group>

        <v-alert :value="paymentAlert && paymentAlertMessage != ''" border="left" type="warning" prominent outlined transition="scale-transition">
          {{ paymentAlertMessage }}
        </v-alert>

        <div v-show="payMethod1inited && payMethod == 5">
          <van-form v-show="monerisFrameVisible">
            <div class="card-holder-label">Card Holder</div>
            <van-field v-model="cardHolder" class="card-holder-input" />
          </van-form>

          <iframe style="padding:10px 20px;margin-top:5px;" ref="monerisFrame" v-show="monerisFrameVisible" v-on:load="monerisFrameLoaded" :src="htSrc" frameborder="0" width="100%"
            height="220px"></iframe>
          <div class="payment-err-msg" ref="monerisResponse">{{ monerisResponseError }}</div>

          <div class="pay-panel">
            <van-button :disabled="!monerisFrameVisible ||
              cardHolder == '' ||
              billingAddress === undefined ||
              (shippingMethod == '1' && storeLocationSelected == '') ||
              (shippingMethod == '2' && shippingAddressSelected == '')
              " class="pay-button" round @click="monerisSubmit">
              PAY</van-button>
          </div>

          <div>{{ errorMsg }}</div>
        </div>

        <div v-show="payMethod == 6">
          <div v-show="$store.getters.isMobile == 'web'">Click the icon to redirect to make payment</div>
          <v-row align="center" v-show="!$store.getters.isMobile">
            <v-col cols="12" class="text-center">Scan the QR Code to make payment </v-col>
            <v-col> <img class="float-right" src="../assets/img/alipay.png" /> </v-col>
            <v-col> <qrcode-vue size="120" :value="aliPayUrl" v-show="aliPayUrl" /> </v-col>
            <v-col cols="12" class="text-center">Click <u @click="initAlipay">here</u> to reftesh QR Code if needed </v-col>
          </v-row>
          <!-- <iframe
          :src="'data:text/html;charset=utf-8,' + encodeURI(securePayHtml)"
          onload='javascript:(function(o){o.style.height=o.contentWindow.document.body.scrollHeight+"px";}(this));'
          style="height:200px;width:100%;border:none;overflow:hidden;"
        ></iframe> -->
        </div>

        <v-row v-show="payMethod == 7">
          <div v-show="$store.getters.isMobile == 'web'">Click the icon to redirect to make payment</div>
          <v-row align="center" v-show="!$store.getters.isMobile">
            <v-col cols="12" class="text-center">Scan the QR Code to make payment </v-col>
            <v-col> <img class="float-right" src="../assets/img/wechatpay.png" /> </v-col>
            <v-col> <qrcode-vue size="120" :value="weChatPayUrl" v-show="weChatPayUrl" /> </v-col>
            <v-col cols="12" class="text-center">Click <u @click="initWeChatPay">here</u> to reftesh QR Code if needed </v-col>
          </v-row>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
import { Dialog } from "vant";
import aboutUs from "./aboutUs.vue";

export default {
  components: { aboutUs },
  computed: {
    member() {
      return this.$store.state.member;
    },
    addresses() {
      return this.$store.state.addresses;
    },
    orderHeader() {
      let header = {};
      if ("header" in this.cartData) {
        header = this.cartData.header;
      }
      return header;
    },
    orderItems() {
      let detail = {};
      if ("detail" in this.cartData) {
        detail = this.cartData.detail;
      }
      return detail;
    },
    billingAddress() {
      if (this.addresses == null || this.address.length == 0) {
        return undefined;
      } else if (this.shippingMethod == "2" && this.shippingAddressSelected != "" && this.sameAsShippingAddress) {
        return this.addresses.filter((addr) => addr.AddrName == this.shippingAddressSelected)[0];
      } else {
        return this.addresses.filter((addr) => addr.AddrName == this.billingAddressSelected)[0];
      }
    },
    paymentAlert() {
      return (
        (this.payMethod == 6 && this.$store.getters.isMobile && this.$store.getters.isWechatBrowser) ||
        (this.payMethod == 7 && this.$store.getters.isMobile && !this.$store.getters.isWechatBrowser)
      );
    },
  },
  data() {
    return {
      paymentAlertMessage: "",
      //orderHeader: {},
      //orderItems: [],
      errorMsg: "",
      radio: "",
      shippingMethod: "1",
      shippingAddressSelected: "",
      billingAddressSelected: "",
      storeLocationSelected: "",
      address: {},
      cartData: {},
      storeLocations: [],

      payMethod: "1",
      payMethod1inited: false,
      aliPayUrl: "",
      aliPayOrderId: "",
      aliPayNotifyKey: "",
      weChatPayUrl: "",
      weChatPayOrderId: "",
      weChatPayNotifyKey: "",
      securePayHtml: "",
      securePayOrderId: "",
      wsConnect: null,

      cardHolder: "",
      monerisResponseError: "",
      monerisFrameVisible: false,
      htProfileId: "",

      htDisplayLabels: "1",
      htEnableExpDate: "1",
      htEnableCVD: "1",
      htCssBody: "background:white;",
      //htCssTextbox: "border-width:1px; height: 32px; padding: 0 10px; margin-top:5px; margin-bottom:10px; background-color: whitesmoke; font-size: 14px;color: black; border-top: 0; border-right: 0 !important; border-left: 0 !important; border-bottom: 1px solid silver !important; font-family: 'Open Sans', sans-serif; font-weight: 400;",
      htCssTextbox: "height: 32px; padding: 0 10px; margin-top:5px; margin-bottom:10px;",
      htCssTextboxPan: "width:200px;",
      htCssTextboxExp: "width:80px;",
      htCssTextboxCVD: "width:60px;",
      htCssInputLabel: ";",
      htCssLabelPan: "font-family: 'Roboto', sans-serif !important;",
      htCssLabelExp: "font-family: 'Roboto', sans-serif !important;",
      htCssLabelCVD: "font-family: 'Roboto', sans-serif !important;",
      htExpLabel: "Expiry Date (MMYY)",
      //"font-family: 'Open Sans',sans-serif; font-weight: 600; font-size: 14px; color: black; margin-bottom: 10px;",

      htUrl: "",
      htRespOrigin: "",

      htSrc: "",

      sameAsShippingAddress: true,
    };
  },

  mounted() {
    this.getStoreLocations();
    this.getCartItems();

    // this.monerisFrameSrc();
    if (window.addEventListener) {
      window.addEventListener("message", this.monerisMsgListener, false);
    } else if (window.attachEvent) {
      window.attachEvent("onmessage", this.monerisMsgListener);
    }
    // check is it a call back?
    let plen = Object.keys(this.$route.query).length;
    if (plen > 0) {
      // console.log(this.$route.query);
      this.$ajax2log({ from: "co cb", query: this.$route.query });
      if ("ptype" in this.$route.query) {
        let obj = JSON.parse(localStorage.getItem("orderObj"));
        // localStorage.removeItem('orderObj');
        if (this.$route.query.ptype == "ALI") {
          obj.data.billto = {
            billType: "ALIPAY",
            orderId: this.$route.query.orderID,
            tranId: this.$route.query.tranID,
            status: this.$route.query.status,
            query: this.$route.query,
          };
          this.postOrder(obj, true);
        } else if (this.$route.query.ptype == "WECHAT") {
          obj.data.billto = {
            billType: "WECHATPAY",
            orderId: this.$route.query.orderId,
            tranId: this.$route.query.tranID,
            status: this.$route.query.status,
            query: this.$route.query,
          };
          this.postOrder(obj, true);
        }
      }
    }
  },
  beforeUnmount() {
    if (this.wsConnect) {
      this.wsConnect.close();
      this.wsConnect = null;
    }
  },
  beforeDestroy() {
    if (window.removeEventListener) {
      window.removeEventListener("message", this.monerisMsgListener);
    } else if (window.detachEvent) {
      window.detachEvent("onmessage", this.monerisMsgListener);
    }
  },

  methods: {
    // ------------------------------------------------------------------------ toGetMemberAddress
    toGetMemberAddress(addressName) {
      let obj = {
        AppVersion: this.$version,
        SessionId: this.member.SessionId,
        SessionToken: this.member.SessionToken,
        AddrName: addressName,
      };
      this.$ajax2
        .post("GetMemberAddress", obj, this.$ajaxHeader)
        .then((rpdata) => {
          if (rpdata.data.meta.code == "200") {
            this.address = rpdata.data.data;
          } else {
            alert("fail to retrieve addresses");
          }
        })
        .catch((err) => {
          console.log(err);
        }); // eslint-disable-line
    },
    // ------------------------------------------------------------------------ getStoreLocations
    getStoreLocations() {
      this.$ajax2
        .post("GetStoreLocations", { AppVersion: this.$version }, this.$ajaxHeader)
        .then((rpdata) => {
          if (rpdata.data.meta.code == "200") {
            this.storeLocations = rpdata.data.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // ------------------------------------------------------------------------ cardPayment
    cardPayment() {
      this.$router.push({ name: "cardPayment" });
    },
    // ------------------------------------------------------------------------ resetPayment
    resetPayment() {
      this.payMethod = "1";
      this.payMethod1inited = false;
      this.aliPayUrl = "";
      this.aliPayOrderId = "";
      this.aliPayNotifyKey = "";
      this.weChatPayUrl = "";
      this.weChatPayOrderId = "";
      this.weChatPayNotifyKey = "";
      this.securePayHtml = "";
      this.securePayOrderId = "";
    },
    // ------------------------------------------------------------------------ getCartItems
    getCartItems() {
      let obj = {
        AppVersion: this.$version,
        language: localStorage.getItem("lang"),
        SessionId: this.member.SessionId,
        SessionToken: this.member.SessionToken,
        addressName: this.shippingAddressSelected,
        storeId: this.storeLocationSelected,
      };
      this.$ajax2
        .post("GetCartItems", obj, this.$ajaxHeader)
        .then((rpdata) => {
          if (rpdata.data.meta.code == "200") {
            this.cartData = rpdata.data.data;

            if (this.storeLocationSelected == "" && this.billingAddressSelected == "" && this.shippingAddressSelected == "") {
              if (this.orderHeader.DefaultStoreId != "") {
                this.storeLocationSelected = this.orderHeader.DefaultStoreId;
              }

              if (this.addresses != null && this.addresses.length > 0) {
                if (this.orderHeader.DefaultBillToAddrId > 0) {
                  let addr = this.addresses.filter((addr) => addr.AddrId == this.orderHeader.DefaultBillToAddrId)[0];
                  if (addr !== undefined) {
                    this.billingAddressSelected = addr.AddrName;
                  }
                } else {
                  let addr = this.addresses[0];
                  if (addr !== undefined) {
                    this.billingAddressSelected = addr.AddrName;
                  }
                }

                if (this.orderHeader.DefaultShipToAddrId > 0) {
                  let addr = this.addresses.filter((addr) => addr.AddrId == this.orderHeader.DefaultShipToAddrId)[0];
                  if (addr !== undefined) {
                    this.shippingAddressSelected = addr.AddrName;
                  }
                } else {
                  let addr = this.addresses[0];
                  if (addr !== undefined) {
                    this.shippingAddressSelected = addr.AddrName;
                  }
                }
              }

              if (this.shippingAddressSelected != "") {
                this.storeLocationSelected = "";
              }

              this.sameAsShippingAddress = (this.shippingAddressSelected == this.billingAddressSelected);

              if (this.shippingAddressSelected != "") {
                this.shippingMethod = "2";
              } else {
                this.shippingMethod = "1";
              }
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // ------------------------------------------------------------------------ getOrderObj
    getOrderObj() {
      if ("billto" in this.cartData) {
        this.cartData.billto.billingAddress = this.billingAddress;
        this.cartData.billto.cardHolder = this.cardHolder;
      }
      return {
        AppVersion: this.$version,
        language: localStorage.getItem("lang"),
        SessionId: this.member.SessionId,
        SessionToken: this.member.SessionToken,
        data: this.cartData,
      };
    },
    // ------------------------------------------------------------------------ placeOrder
    placeOrder(dummy = false) {
      if (dummy) {
        console.log(this.getOrderObj());
      } else {
        this.postOrder(this.getOrderObj());
      }
    },
    // ------------------------------------------------------------------------ postOrder
    postOrder(obj, toHome = false) {
      this.$ajax2
        .post("NewOrder", obj, this.$ajaxHeader)
        .then((rpdata) => {
          if (rpdata.data.meta.code == "200") {
            this.$store.commit("cartCount", 0);
            this.$store.commit("orderConfirmed", { order: rpdata.data.data });
            this.$router.push({ name: "orderConfirmed" });

            // this.$router.push({ name: "home" });
            // Dialog.alert({
            //   title: "Order ID : " + rpdata.data.data.OrderId,
            //   message: "Thank you! Your order was successfully submitted!",
            //   confirmButtonText: "OK",
            // }).then(() => {
            //   // on close
            // });
          } else if (rpdata.data.meta.msg != "") {
            if (toHome) {
              this.$router.push({ name: "home" });
            }
            this.resetPayment();
            Dialog.alert({
              title: "Failed to place order",
              message: rpdata.data.meta.msg,
              confirmButtonText: "OK",
            }).then(() => { });
          }
        })
        .catch((err) => {
          if (toHome) {
            this.$router.push({ name: "home" });
          }
          this.resetPayment();
          Dialog.alert({
            title: "Unknonwn error during placing order",
            message: rpdata.data.meta.msg,
            confirmButtonText: "OK",
          }).then(() => { });
        });
    },

    // ------------------------------------------------------------------------ addAddress
    addAddress() {
      this.$router.push({ name: "member" });
    },
    // ------------------------------------------------------------------------ addressChanged
    addressChanged() {
      if (this.shippingMethod == "1") {
        this.shippingAddressSelected = "";

        if (this.storeLocationSelected == "" && this.storeLocations.length > 0) {
          let addr = this.storeLocations[0];
          this.storeLocationSelected = addr.storeId;
        }
      } else if (this.shippingMethod == "2") {
        this.storeLocationSelected = "";

        if (this.shippingAddressSelected == "" && this.addresses != null && this.addresses.length > 0) {
          let addr = this.addresses[0];
          this.shippingAddressSelected = addr.AddrName;
        }
      }

      // reload cart because price could be different by shipping address
      this.getCartItems();
    },
    // ------------------------------------------------------------------------ payMethodChanged
    payMethodChanged() {
      if (this.payMethod == 5) {
        this.paymentAlertMessage = "";
        if (!this.payMethod1inited) {
          this.monerisFrameSrc();
        }
        // alipay
      } else if (this.payMethod == 6) {
        if (this.$store.getters.isWechatBrowser) {
          this.paymentAlertMessage = "This browser does not support this payment method, please try a different browser.";
        } else {
          this.paymentAlertMessage = "";
          if (this.aliPayOrderId == "") {
            this.initAlipay();
          }
        }
        // wechatpay
      } else if (this.payMethod == 7) {
        if (this.$store.getters.isWechatBrowser || !this.$store.getters.isMobile) {
          this.paymentAlertMessage = "";
          if (this.weChatPayOrderId == "") {
            this.initWeChatPay();
          }
        } else {
          this.paymentAlertMessage = "This browser does not support this payment method, please in try within WeChat App or Desktop PC";
        }
      }
    },
    // ------------------------------------------------------------------------ initWSConnect
    initWSConnect() {
      if (this.wsConnect == null) {
        // onopen, onclose, onmessage, onerror, send(message)
        this.wsConnect = new WebSocket(this.$store.state.ws1host);
        this.wsConnect.onmessage = (event) => {
          let obj = JSON.parse(event.data);
          if (obj.channel == this.aliPayNotifyKey) {
            this.cartData.billto = { billType: "ALIPAY", orderId: this.aliPayOrderId, notifyKey: this.aliPayNotifyKey, data: obj.data };
            this.placeOrder();
          } else if (obj.channel == this.weChatPayNotifyKey) {
            this.cartData.billto = { billType: "WECHATPAY", orderId: this.weChatPayOrderId, notifyKey: this.weChatPayNotifyKey, data: obj.data };
            this.placeOrder();
          }
        };
        this.wsConnect.onopen = (event) => {
          console.log("Successfully connected to the websocket server...");
        };
        this.wsConnect.onclose = (e) => {
          console.log("Socket is closed. Reconnect will be attempted in 1 second.", e.reason);
          setTimeout(function () {
            connect();
          }, 1000);
        };
        this.wsConnect.onerror = (err) => {
          console.error("Socket encountered error: ", err.message, "Closing socket");
          this.wsConnect.close();
          this.wsConnect = null;
        };
      }
    },
    // ------------------------------------------------------------------------ initAlipay
    initAlipay() {
      if (!this.$store.getters.isMobile) {
        this.initWSConnect();
      }
      this.aliPayUrl = "";
      this.aliPayOrderId = "";
      let obj = {
        AppVersion: this.$version,
        SessionId: this.member.SessionId,
        SessionToken: this.member.SessionToken,
        Amount: this.orderHeader.Total.toString(),
        Mobile: this.$store.getters.isMobile,
        ReturnUrl: window.location.href.replace("checkout", "orderconfirmed") + "?ptype=ALI",
      };
      this.$ajax2
        .post("AliPay", obj, this.$ajaxHeader)
        .then((rpdata) => {
          if (rpdata.data.meta.code == "200") {
            if (!this.$store.getters.isMobile) {
              this.aliPayNotifyKey = rpdata.data.data.notificationKey;
              this.wsConnect.send('{"subscribe":"' + this.aliPayNotifyKey + '"}');
              this.aliPayUrl = rpdata.data.data.codeUrl;
              this.aliPayOrderId = rpdata.data.data.orderId;
            } else {
              if (rpdata.data.data.codeUrl) {
                this.cartData.billto = { billType: "ALIPAY", orderId: rpdata.data.data.orderId };
                localStorage.setItem("orderObj", JSON.stringify(this.getOrderObj()));
                window.location.replace(rpdata.data.data.codeUrl);
              }
            }
          }
        })
        .catch((err) => { }); // eslint-disable-line
    },
    // ------------------------------------------------------------------------ initWeChatPay
    initWeChatPay() {
      if (!this.$store.getters.isMobile) {
        this.initWSConnect();
      }
      this.weChatPayUrl = "";
      this.weChatPayOrderId = "";
      let obj = {
        AppVersion: this.$version,
        SessionId: this.member.SessionId,
        SessionToken: this.member.SessionToken,
        Amount: this.orderHeader.Total.toString(),
        Mobile: this.$store.getters.isMobile,
        ReturnUrl: window.location.href.replace("checkout", "orderconfirmed") + "?ptype=WECHAT",
      };
      this.$ajax2
        .post("WeChatPay", obj, this.$ajaxHeader)
        .then((rpdata) => {
          if (rpdata.data.meta.code == "200") {
            if (!this.$store.getters.isMobile) {
              this.weChatPayNotifyKey = rpdata.data.data.notificationKey;
              this.wsConnect.send('{"subscribe":"' + this.weChatPayNotifyKey + '"}');
              this.weChatPayUrl = rpdata.data.data.codeUrl;
              this.weChatPayOrderId = rpdata.data.data.orderId;
            } else {
              console.log(rpdata.data.data);
              if (rpdata.data.data.codeUrl) {
                this.cartData.billto = { billType: "WECHATPAY", orderId: rpdata.data.data.orderId };
                localStorage.setItem("orderObj", JSON.stringify(this.getOrderObj()));
                window.location.replace(rpdata.data.data.codeUrl);
              }
            }
          }
        })
        .catch((err) => { }); // eslint-disable-line
    },
    // ------------------------------------------------------------------------ aliPaySubmit
    aliPaySubmit() {
      if (this.payMethod == 5) {
      }
    },
    // ------------------------------------------------------------------------ wechatPaySubmit
    wechatPaySubmit() {
      if (this.payMethod == 6) {
      }
    },
    // ------------------------------------------------------------------------ securePaySubmit
    securePaySubmit() {
      let obj = {
        AppVersion: this.$version,
        SessionId: this.member.SessionId,
        SessionToken: this.member.SessionToken,
        Amount: this.orderHeader.Total.toString(),
        ReturnUrl: window.location.href.replace("checkout", "orderconfirmed") + "?ptype=SECURE",
      };
      this.$ajax2
        .post("SecurePay", obj, this.$ajaxHeader)
        .then((rpdata) => {
          if (rpdata.data.meta.code == "200") {
            // console.log(rpdata.data.data);
            var doc = document.open("text/html");
            doc.write(rpdata.data.data.codeUrl);
            doc.close();
            // this.securePayHtml = rpdata.data.data.codeUrl;
            // this.securePayOrderId = rpdata.data.data.orderId;
          }
        })
        .catch((err) => {
          console.log(err);
        }); // eslint-disable-line
    },
    // ------------------------------------------------------------------------ monerisFrameSrc
    monerisFrameSrc() {
      let obj = {
        AppVersion: this.$version,
        SessionId: this.member.SessionId,
        SessionToken: this.member.SessionToken,
      };
      this.payMethod1inited = true;
      this.$ajax2
        .post("PaymentProfileInfo", obj, this.$ajaxHeader)
        .then((rpdata) => {
          if (rpdata.data.meta.code == "200") {
            this.htProfileId = rpdata.data.data.ProfileId;
            this.htUrl = rpdata.data.data.ProfileUrl;
            var matches = this.htUrl.match(/^https?\:\/\/([^\/?#]+)(?:[\/?#]|$)/i);
            this.htRespOrigin = matches && matches[1];
            // this.htUrl = "https://esqa.moneris.com/HPPtoken/index.php";

            // check the parameters from
            // https://developer.moneris.com/en/Documentation/NA/E-Commerce%20Solutions/Hosted%20Solutions/Hosted%20Tokenization
            var params = "?id=" + this.htProfileId;
            params += "&display_labels=" + this.htDisplayLabels;
            params += "&enable_exp=" + this.htEnableExpDate;
            params += "&enable_cvd=" + this.htEnableCVD;
            params += "&css_body=" + this.htCssBody;
            params += "&css_textbox=" + this.htCssTextbox;
            params += "&css_textbox_pan=" + this.htCssTextboxPan;
            params += "&css_textbox_exp=" + this.htCssTextboxExp;
            params += "&css_textbox_cvd=" + this.htCssTextboxCVD;
            params += "&css_input_label=" + this.htCssInputLabel;
            params += "&css_label_pan=" + this.htCssLabelPan;
            params += "&css_label_exp=" + this.htCssLabelExp;
            params += "&css_label_cvd=" + this.htCssLabelCVD;
            params += "&exp_label=" + this.htExpLabel;
            this.htSrc = this.htUrl + params;
          } else {
            alert("failed to setup card payment");
          }
        })
        .catch((err) => {
          console.log(err);
        }); // eslint-disable-line
    },
    // ------------------------------------------------------------------------ monerisMsgListener
    monerisMsgListener(e) {
      // include monerisFrameVisible to prevent
      if (e.origin != null && this.htRespOrigin != "" && e.origin.includes(this.htRespOrigin) && this.monerisFrameVisible) {
        var respData = eval("(" + e.data + ")");
        if ("errorMessage" in respData) {
          this.monerisResponseError = respData.errorMessage;
        } else if ("dataKey" in respData) {
          this.monerisFrameVisible = false;
          this.cartData.billto = respData; //.dataKey;
          this.cartData.billto.billType = "MONERIS";
          this.placeOrder();
          // this.monerisResponseError = "";
        }
      }
    },
    // ------------------------------------------------------------------------ monerisFrameLoaded
    monerisFrameLoaded() {
      this.monerisFrameVisible = true;
    },
    // ------------------------------------------------------------------------ monerisSubmit
    monerisSubmit() {
      this.$refs.monerisFrame.contentWindow.postMessage("tokenize", this.htUrl);
      return false;
    },
  },
};
</script>

<style>
.checkout-title {
  padding-top: 10px;
  text-align: center;
  font-size: 1.5em;
}

.order-item {
  margin-top: 10px;
  padding: 10px;
}

.order-item .price {
  text-align: right;
}

.order-item .shipping-note {
  font-size: 0.7em;
  color: red;
  /* text-transform: capitalize; */
}

.card-holder-label {
  margin-top: 20px;
  margin-left: 20px;
  color: black;
}

.card-holder-input {
  border-width: 1px;
  border-style: solid;
  width: 200px;
  height: 32px;
  margin: 5px 0px 10px 20px;
  padding: 0px 10px;
  color: black;
}

.card-holder-input .van-field__control {
  height: 32px;
  font-size: 13.3333px !important;
  font-family: Arial !important;
}

.order-total {
  padding: 10px;
}

.order-total .van-row {
  margin-top: 10px;
}

.order-total .subtotal .title {
  text-align: right;
}

.order-total .subtotal .amount {
  text-align: right;
}

.order-total .freight .title {
  text-align: right;
}

.order-total .freight .amount {
  text-align: right;
}

.order-total .taxes .title {
  text-align: right;
}

.order-total .taxes .amount {
  text-align: right;
}

.order-total .total .title {
  text-align: right;
}

.order-total .total .amount {
  text-align: right;
  font-weight: bold;
}

.special-shipping-message {
  font-size: 1em;
  color: red;
  padding: 5px 0px;
}

.ss-pay-method label {
  background: rgb(245, 247, 238);
  border: 1px solid rgb(161, 161, 161);
  padding: 0.5rem 1.25rem;
  border-radius: 5px;
  cursor: pointer;
  color: #444;
  transition: box-shadow 400ms ease;
}

.ss-pay-method label:hover {
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12);
}

.ss-pay-method .v-input--selection-controls__input {
  display: none;
}

.ss-pay-method .v-item--active label {
  background: #2196f3;
  color: #fff;
  border-color: #2196f3;
}

.pay-panel {
  text-align: center;
  margin-top: 10px;
  padding-bottom: calc(5px + env(safe-area-inset-bottom));
}

.pay-button {
  /* width: 50%; */
  /* min-width: 100px; */
  width: 150px;
  background-color: #8cdbcc;
}

.payment-err-msg {
  text-transform: capitalize;
  color: rgb(161, 28, 28);
  padding: 10px 20px;
}

.address-box {
  font-size: 0.9em;
  margin-left: 10px;
}

#checkout .address {
  text-align: left;
  width: 97%;
  height: 100%;
  border-radius: 8px;
  border: 1px solid rgb(197, 218, 224);
  margin-bottom: -10px;
  margin-top: -10px;
  padding: 10px;
}

#checkout {
  width: 100%;
  margin-bottom: 20px;
  /* height: -webkit-fill-available; */
}

.content1 {
  padding: 0px;
  --margin: 0px !important;
}

.van-radio {
  padding: 10px;
  margin-top: 0px !important;
}
</style>
